var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5d78ff",
    opacity: 0.3,
    d: "M6.833,5h8.333a.833.833,0,1,1,0,1.667H6.833A.833.833,0,0,1,6.833,5Zm0,3.333h8.333a.833.833,0,1,1,0,1.667H6.833a.833.833,0,1,1,0-1.667Zm0,3.333h8.333a.833.833,0,1,1,0,1.667H6.833a.833.833,0,0,1,0-1.667Zm0,3.333h8.333a.833.833,0,1,1,0,1.667H6.833a.833.833,0,0,1,0-1.667Z",
    transform: "translate(-1 -0.833)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#5d78ff",
    d: "M5.25,2A1.25,1.25,0,0,1,6.5,3.25V17.417a1.25,1.25,0,1,1-2.5,0V3.25A1.25,1.25,0,0,1,5.25,2ZM16.083,2a1.25,1.25,0,0,1,1.25,1.25V17.417a1.25,1.25,0,1,1-2.5,0V3.25A1.25,1.25,0,0,1,16.083,2Z",
    transform: "translate(-0.667 -0.333)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRack);
export default __webpack_public_path__ + "static/media/rack.342fc9f4325edd7cec4fb8991ab9979d.svg";
export { ForwardRef as ReactComponent };